(function () {
  function toggle(nodes, attr, id) {
    nodes.forEach(function (n) {
      n.classList.toggle('is-active', n.getAttribute(attr) === String(id));
    });
  }

  function perServing(moneyStr, servings) {
    if (!servings || servings <= 0) return '';
    var num = parseFloat(String(moneyStr).replace(/[^0-9.]/g, ''));
    if (!num) return '';
    var sym = String(moneyStr).replace(/[0-9.,\s]/g, '') || '$';
    return sym + (num / servings).toFixed(2) + '/serving';
  }

  function applyCollapse(buybox) {
    buybox.querySelectorAll('.dgt-buybox__option').forEach(function (option) {
      var details = option.querySelector('[data-buybox-details]');
      if (!details) return;
      var open = option.classList.contains('dgt-buybox__option--open') || option.classList.contains('is-selected');
      if (open) {
        details.classList.add('is-open');
        details.style.maxHeight = details.scrollHeight + 'px';
      } else {
        details.classList.remove('is-open');
        details.style.maxHeight = '0px';
      }
    });
  }

  function bbMoneyNum(s) { return parseFloat(String(s || '').replace(/[^0-9.]/g, '')) || 0; }
  function bbMoneyFmt(n, sample) { var sym = String(sample || '$').replace(/[0-9.,\s]/g, '') || '$'; return sym + n.toFixed(2); }

  // Map a pack quantity to its subscription plan by name ("2-Pack ..." -> qty 2,
  // "3-Pack ..." -> qty 3, anything else -> qty 1 / base plan).
  function planForQty(allocs, n) {
    if (!allocs || !allocs.length) return null;
    var i, label;
    // Prefer the selling-plan GROUP name (e.g. "2-Pack 36% Off"); fall back to plan name.
    for (i = 0; i < allocs.length; i++) {
      label = String(allocs[i].group || allocs[i].name || '').toLowerCase();
      if (n >= 2 && (label.indexOf(n + '-pack') > -1 || label.indexOf(n + ' pack') > -1 || label.indexOf(n + 'pack') > -1)) return allocs[i];
    }
    if (n === 1) {
      for (i = 0; i < allocs.length; i++) {
        label = String(allocs[i].group || allocs[i].name || '').toLowerCase();
        if (label.indexOf('2-pack') < 0 && label.indexOf('3-pack') < 0 && label.indexOf('2 pack') < 0 && label.indexOf('3 pack') < 0) return allocs[i];
      }
    }
    return allocs[0];
  }

  function updateBuybox(root, vdata, variantId) {
    var buybox = root.querySelector('[data-dgt-buybox]');
    if (!buybox) return;
    var vd = vdata[variantId];
    var variantInput = buybox.querySelector('[data-buybox-variant]');
    var spInput = buybox.querySelector('[data-buybox-sellingplan]');
    var freq = buybox.querySelector('[data-buybox-freq]');
    var otpPrice = buybox.querySelector('[data-otp-price]');
    var ssPrice = buybox.querySelector('[data-ss-price]');
    var ssCompare = buybox.querySelector('[data-ss-compare]');
    var addBtn = buybox.querySelector('.dgt-buybox__add');

    if (variantInput) variantInput.value = variantId;
    if (!vd) return;

    var qtyMode = buybox.dataset.qtyMode === '1';
    var packSize = parseInt(buybox.dataset.packSize, 10) || 1;
    var packCount = parseInt(buybox.dataset.packCount, 10) || 1;
    var units = packSize * packCount;
    var unitNum = bbMoneyNum(vd.price);
    var packPlan = qtyMode ? planForQty(vd.allocations, packSize) : null;
    if (qtyMode) {
      var qInput0 = buybox.querySelector('[data-qty-input]'); if (qInput0) qInput0.value = units;
      var psInput = buybox.querySelector('[data-pack-size-input]'); if (psInput) psInput.value = packSize;
      var pcDisp = buybox.querySelector('[data-packcount-display]'); if (pcDisp) pcDisp.textContent = packCount;
    }

    if (otpPrice) otpPrice.textContent = qtyMode ? bbMoneyFmt(unitNum * units, vd.price) : vd.price;
    if (ssCompare) ssCompare.textContent = qtyMode ? bbMoneyFmt(unitNum * units, vd.price) : vd.price;

    if (!qtyMode && freq && vd.allocations) {
      var current = freq.value;
      freq.innerHTML = '';
      vd.allocations.forEach(function (a) {
        var opt = document.createElement('option');
        opt.value = a.id;
        opt.textContent = a.name;
        opt.dataset.price = a.price;
        opt.dataset.compare = a.compare;
        freq.appendChild(opt);
      });
      if (current && freq.querySelector('option[value="' + current + '"]')) freq.value = current;
    }

    var subRadio = buybox.querySelector('[data-mode="sub"]');
    var isSub = subRadio && subRadio.checked;
    var freqWrap = buybox.querySelector('.dgt-buybox__freq');

    var subPerUnit = 0;
    var subPriceStr = vd.allocations && vd.allocations.length ? vd.allocations[0].price : vd.price;
    if (isSub && vd.allocations && vd.allocations.length) {
      var planId, planUnitStr;
      // The frequency <select> is the source of truth for the subscription plan (delivery cadence).
      // Pack buttons set quantity (units) only — never the plan — even though these plans' GROUPS are
      // mislabeled "2-Pack/3-Pack" in Appstle. Fall back to packPlan / first plan only when there is
      // genuinely no frequency dropdown to read from.
      if (freq && freq.value) {
        planId = freq.value;
        var sel = freq.selectedOptions[0];
        planUnitStr = sel ? sel.dataset.price : vd.allocations[0].price;
      } else if (qtyMode && packPlan) {
        planId = packPlan.id; planUnitStr = packPlan.price;
      } else {
        planId = vd.allocations[0].id; planUnitStr = vd.allocations[0].price;
      }
      if (spInput) { spInput.disabled = false; spInput.value = planId; }
      subPerUnit = bbMoneyNum(planUnitStr);
      subPriceStr = qtyMode ? bbMoneyFmt(subPerUnit * units, vd.price) : planUnitStr;
      if (ssPrice) ssPrice.textContent = subPriceStr;
      // The dropdown drives the plan, so keep it visible whenever subscribing.
      if (freqWrap) freqWrap.hidden = false;
    } else {
      if (spInput) { spInput.disabled = true; spInput.value = ''; }
      if (freqWrap) freqWrap.hidden = true;
      if (vd.allocations && vd.allocations.length) {
        var basePer = qtyMode && packPlan ? bbMoneyNum(packPlan.price) : bbMoneyNum(vd.allocations[0].price);
        subPerUnit = basePer;
        if (ssPrice) ssPrice.textContent = qtyMode ? bbMoneyFmt(basePer * units, vd.price) : vd.allocations[0].price;
      }
    }

    var otpPerserv = buybox.querySelector('[data-otp-perserv]');
    if (otpPerserv) otpPerserv.textContent = perServing(vd.price, vd.servings);
    var ssPerserv = buybox.querySelector('[data-ss-perserv]');
    if (ssPerserv) ssPerserv.textContent = perServing(bbMoneyFmt(subPerUnit || bbMoneyNum(subPriceStr), vd.price), vd.servings);

    var otpCompare = buybox.querySelector('[data-otp-compare]');
    if (otpCompare) {
      if (vd.onSale && vd.compareText) { otpCompare.textContent = vd.compareText; otpCompare.hidden = false; }
      else { otpCompare.hidden = true; }
    }

    var discountBar = buybox.querySelector('[data-discount-bar]');
    if (discountBar) discountBar.hidden = !isSub;

    var saveEl = buybox.querySelector('[data-ss-save]');
    if (saveEl && vd.allocations && vd.allocations.length) {
      var subStr;
      if (qtyMode && packPlan) subStr = packPlan.price;
      else { var sel2 = freq && freq.selectedOptions[0]; subStr = sel2 ? sel2.dataset.price : vd.allocations[0].price; }
      var full = parseFloat((vd.price || '').replace(/[^0-9.]/g, ''));
      var sub = parseFloat((subStr || '').replace(/[^0-9.]/g, ''));
      if (full && sub && full > sub) {
        saveEl.textContent = 'Save ' + Math.round((full - sub) / full * 100) + '%';
        saveEl.hidden = false;
      } else {
        saveEl.hidden = true;
      }
    }

    buybox.querySelectorAll('.dgt-buybox__option').forEach(function (o) {
      var r = o.querySelector('input[type="radio"]');
      o.classList.toggle('is-selected', r && r.checked);
    });
    applyCollapse(buybox);

    // Low-stock display: warning at <=10, exact "Only N left" at <=4 (tracked inventory only).
    var lowstock = buybox.querySelector('[data-lowstock]');
    if (lowstock) {
      var lsText = lowstock.querySelector('[data-lowstock-text]');
      var inv = (typeof vd.inv === 'number') ? vd.inv : parseInt(vd.inv, 10);
      if (vd.invTracked && inv > 0 && inv <= 10) {
        if (inv <= 4) {
          lowstock.classList.add('dgt-lowstock--urgent');
          if (lsText) lsText.textContent = 'Only ' + inv + ' left!';
        } else {
          lowstock.classList.remove('dgt-lowstock--urgent');
          if (lsText) lsText.textContent = 'Low stock — order soon';
        }
        lowstock.hidden = false;
      } else {
        lowstock.hidden = true;
      }
    }

    if (addBtn) {
      if (vd.available === false) { addBtn.setAttribute('disabled', 'disabled'); }
      else { addBtn.removeAttribute('disabled'); }
    }

    // Native preorder: relabel the button, show the note, and enable the _preorder line-item
    // property for the selected variant (driven by its custom.preorder metafield).
    var labelEl = buybox.querySelector('.dgt-buybox__add .add-to-cart-text__content');
    var preNote = buybox.querySelector('[data-preorder-note]');
    var preProp = buybox.querySelector('[data-preorder-prop]');
    if (vd.preorder) {
      if (labelEl) labelEl.textContent = 'Preorder - Add to Cart';
      if (preNote) { if (vd.preorderNote) preNote.textContent = vd.preorderNote; preNote.hidden = false; }
      if (preProp) preProp.disabled = false;
      if (addBtn) addBtn.classList.add('dgt-buybox__add--preorder');
    } else {
      if (labelEl) labelEl.textContent = (vd.available === false) ? 'Sold Out' : 'Add to Cart';
      if (preNote) preNote.hidden = true;
      if (preProp) preProp.disabled = true;
      if (addBtn) addBtn.classList.remove('dgt-buybox__add--preorder');
    }
  }

  function initFeatured(root) {
    if (root.dataset.dgtFeaturedReady === '1') return;
    root.dataset.dgtFeaturedReady = '1';

    var dataEl = root.querySelector('[data-dgt-variant-data]');
    var vdata = {};
    if (dataEl) {
      try { vdata = JSON.parse(dataEl.textContent); }
      catch (e) { console.warn('[DGT] variant data JSON failed to parse — PDP sync disabled.', e); vdata = {}; }
    }
    if (!dataEl || !Object.keys(vdata).length) {
      console.warn('[DGT] no variant data found in [data-dgt-variant-data] — selection sync will not work. Check that dgt-pdp.js and the section markup are the same version.');
    }

    var selectorEls = Array.prototype.slice.call(root.querySelectorAll('[data-variant-option]'));
    var galleries = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-variant]'));
    var flavors = Array.prototype.slice.call(root.querySelectorAll('[data-flavor-variant]'));
    var extras = Array.prototype.slice.call(root.querySelectorAll('[data-extras-variant]'));
    var benefits = Array.prototype.slice.call(root.querySelectorAll('[data-benefits-variant]'));
    var testimonials = Array.prototype.slice.call(root.querySelectorAll('[data-testimonial-variant]'));
    var nfTabs = Array.prototype.slice.call(root.querySelectorAll('[data-nf-tab]'));
    var nfPanels = Array.prototype.slice.call(root.querySelectorAll('[data-nf-panel]'));
    var buybox = root.querySelector('[data-dgt-buybox]');

    var startId = null;
    var variantInput = buybox && buybox.querySelector('[data-buybox-variant]');
    if (variantInput && variantInput.value) startId = variantInput.value;
    if (!startId) { for (var firstKey in vdata) { startId = firstKey; break; } }
    var selected = (vdata[startId] && vdata[startId].options) ? vdata[startId].options.slice() : [];

    function optionsEqual(a, b) {
      if (!a || !b || a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) { if (String(a[i]) !== String(b[i])) return false; }
      return true;
    }
    function findVariant(opts) {
      for (var id in vdata) { if (optionsEqual(vdata[id].options, opts)) return id; }
      return null;
    }
    function currentId() { return findVariant(selected) || startId; }

    function moneyNum(str) { return parseFloat(String(str || '').replace(/[^0-9.]/g, '')) || 0; }
    function moneyFmt(num, sample) {
      var sym = String(sample || '$').replace(/[0-9.,\s]/g, '') || '$';
      return sym + num.toFixed(2);
    }

    function packImageFor(vid, qty) {
      var d = vid && vdata[vid];
      if (!d || !d.packImages) return null;
      return d.packImages[String(qty)] || null;
    }
    function thumbUrl(url) {
      if (!url) return url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=200';
    }
    // Swap the active gallery's main image to the selected pack's photo (if provided).
    // On first paint (1-pack, before the shopper has touched the pack selector) we keep
    // the gallery's own main image — e.g. a banner/hero variant image — in place. The
    // pack photo only takes over once the shopper actually clicks a pack, so the 1-pack
    // pouch still appears when "1-Pack" is selected.
    var userPickedPack = false;
    function applyPackImage() {
      var q = (buybox && buybox.dataset.qtyMode === '1') ? (parseInt(buybox.dataset.packSize, 10) || 1) : 1;
      if (q === 1 && !userPickedPack) return;
      var pim = packImageFor(currentId(), q);
      if (!pim) return;
      var mainImg = root.querySelector('.dgt-gallery__panel.is-active [data-gallery-main]');
      if (mainImg) mainImg.src = pim;
    }

    function updatePackPrices() {
      // Quantity-pack mode: each card is simply (unit price x N). No per-pack
      // discount here — the savings live in the subscription rate, not the pack.
      var qtyTiers = Array.prototype.slice.call(root.querySelectorAll('[data-qty-packs] [data-pack-qty]'));
      if (qtyTiers.length) {
        var uid = currentId();
        var uvd = uid && vdata[uid];
        var u = uvd ? moneyNum(uvd.price) : 0;
        qtyTiers.forEach(function (b) {
          var n = parseInt(b.getAttribute('data-pack-qty'), 10) || 1;
          var pe = b.querySelector('[data-pack-price]');
          if (pe && uvd) pe.textContent = moneyFmt(u * n, uvd.price);
          var im = b.querySelector('[data-pack-img]');
          if (im) {
            var pim = packImageFor(uid, n);
            if (pim) im.src = thumbUrl(pim);
            else if (uvd && uvd.img) im.src = uvd.img;
          }
        });
        return;
      }

      var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-dgt-packs] [data-variant-option]'));
      if (!tiers.length) return;
      var unit = 0;
      tiers.forEach(function (pack) {
        if (parseInt(pack.getAttribute('data-amount'), 10) === 1) {
          var idx = parseInt(pack.getAttribute('data-variant-option'), 10);
          var trial = selected.slice();
          trial[idx] = pack.getAttribute('data-value');
          var id = findVariant(trial);
          if (id && vdata[id]) unit = moneyNum(vdata[id].price);
        }
      });
      tiers.forEach(function (pack) {
        var idx = parseInt(pack.getAttribute('data-variant-option'), 10);
        var amt = parseInt(pack.getAttribute('data-amount'), 10) || 1;
        var trial = selected.slice();
        trial[idx] = pack.getAttribute('data-value');
        var id = findVariant(trial);
        if (!id || !vdata[id]) return;
        var price = vdata[id].price;
        var priceEl = pack.querySelector('[data-pack-price]');
        if (priceEl) priceEl.textContent = price;
        var imgEl = pack.querySelector('img');
        if (imgEl && vdata[id].img) imgEl.src = vdata[id].img;
        var saveEl = pack.querySelector('[data-pack-save]');
        var anchorEl = pack.querySelector('[data-pack-anchor]');
        var anchorVal = unit * amt;
        var saveVal = anchorVal - moneyNum(price);
        var show = amt > 1 && unit > 0 && saveVal > 0;
        if (saveEl) {
          if (show) { saveEl.textContent = 'You save ' + moneyFmt(saveVal, price); saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }
        if (anchorEl) {
          if (show) { anchorEl.textContent = moneyFmt(anchorVal, price); anchorEl.hidden = false; }
          else { anchorEl.hidden = true; }
        }
      });
    }

    // Pick black or white text for a given flavor background, based on its
    // luminance (YIQ). Light flavors (gold/pink) -> near-black; dark flavors
    // (maroon/plum) -> white. Keeps badge/label text readable on every flavor.
    function flavorInk(hex) {
      if (!hex) return '';
      var h = String(hex).trim().replace(/^#/, '');
      if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
      if (h.length < 6) return '';
      var r = parseInt(h.slice(0, 2), 16),
          g = parseInt(h.slice(2, 4), 16),
          b = parseInt(h.slice(4, 6), 16);
      var yiq = (r * 299 + g * 587 + b * 114) / 1000;
      return yiq >= 150 ? '#1a1420' : '#ffffff';
    }

    function applyVariant(id) {
      if (!id || !vdata[id]) return;
      var vd = vdata[id];
      if (vd.options) selected = vd.options.slice();

      selectorEls.forEach(function (s) {
        var idx = parseInt(s.getAttribute('data-variant-option'), 10);
        s.classList.toggle('is-active', String(selected[idx]) === s.getAttribute('data-value'));
      });
      if (vd.primary) {
        root.style.setProperty('--flavor-primary', vd.primary);
        var ink = flavorInk(vd.primary);
        if (ink) root.style.setProperty('--flavor-on-primary', ink);
      }
      if (vd.secondary) root.style.setProperty('--flavor-secondary', vd.secondary);

      var flavorNameEl = root.querySelector('[data-flavor-name]');
      var activeFlavor = root.querySelector('[data-variant-option][data-flavor].is-active');
      if (flavorNameEl && activeFlavor) flavorNameEl.textContent = activeFlavor.getAttribute('data-flavor');

      toggle(galleries, 'data-gallery-variant', id);
      toggle(flavors, 'data-flavor-variant', id);
      toggle(benefits, 'data-benefits-variant', id);
      toggle(testimonials, 'data-testimonial-variant', id);
      var activeTest = root.querySelector('[data-testimonial-variant="' + id + '"]');
      if (activeTest && activeTest.dataset.testimonialImg) {
        var tImg = activeTest.querySelector('.dgt-testimonial__product-img');
        if (tImg) tImg.src = activeTest.dataset.testimonialImg;
      }
      extras.forEach(function (e) { e.classList.toggle('is-hidden', e.getAttribute('data-extras-variant') !== String(id)); });

      if (vd.nfKey && (nfTabs.length || nfPanels.length)) {
        var hasTab = nfTabs.some(function (t) { return t.getAttribute('data-nf-tab') === vd.nfKey; });
        if (hasTab) {
          nfTabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-nf-tab') === vd.nfKey); });
          nfPanels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-nf-panel') === vd.nfKey); });
        }
      }

      refreshActiveGallery(root);
      updatePackPrices();
      updateBuybox(root, vdata, id);
      applyPackImage();
    }

    selectorEls.forEach(function (s) {
      s.addEventListener('click', function () {
        var idx = parseInt(s.getAttribute('data-variant-option'), 10);
        var trial = selected.slice();
        trial[idx] = s.getAttribute('data-value');
        var id = findVariant(trial);
        if (id) applyVariant(id);
      });
    });

    nfTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-nf-tab');
        var best = null, bestScore = -1;
        for (var id in vdata) {
          if (vdata[id].nfKey !== key) continue;
          var opts = vdata[id].options || [];
          var score = 0;
          for (var i = 0; i < opts.length; i++) { if (String(opts[i]) === String(selected[i])) score++; }
          if (score > bestScore) { bestScore = score; best = id; }
        }
        if (best) applyVariant(best);
      });
    });


    if (buybox) {
      buybox.querySelectorAll('[data-mode]').forEach(function (r) {
        r.addEventListener('change', function () { updateBuybox(root, vdata, currentId()); });
      });
      var freq = buybox.querySelector('[data-buybox-freq]');
      if (freq) freq.addEventListener('change', function () { updateBuybox(root, vdata, currentId()); });
    }

    // Quantity-pack buttons: pick 1/2/3-Pack -> sets quantity + subscription plan
    // on the single variant (no separate pack variant). Keeps inventory shared.
    var qtyPacks = Array.prototype.slice.call(root.querySelectorAll('[data-qty-packs] [data-pack-qty]'));
    if (qtyPacks.length && buybox) {
      buybox.dataset.qtyMode = '1';
      if (!buybox.dataset.packSize) buybox.dataset.packSize = '1';
      if (!buybox.dataset.packCount) buybox.dataset.packCount = '1';
      qtyPacks.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = parseInt(btn.getAttribute('data-pack-qty'), 10) || 1;
          buybox.dataset.packSize = String(n);
          buybox.dataset.packCount = '1'; // reset pack count when switching pack size
          qtyPacks.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          userPickedPack = true;
          updateBuybox(root, vdata, currentId());
          applyPackImage();
        });
      });
      var pcMinus = buybox.querySelector('[data-packcount-minus]');
      var pcPlus = buybox.querySelector('[data-packcount-plus]');
      if (pcMinus) pcMinus.addEventListener('click', function () {
        buybox.dataset.packCount = String(Math.max(1, (parseInt(buybox.dataset.packCount, 10) || 1) - 1));
        updateBuybox(root, vdata, currentId());
      });
      if (pcPlus) pcPlus.addEventListener('click', function () {
        buybox.dataset.packCount = String((parseInt(buybox.dataset.packCount, 10) || 1) + 1);
        updateBuybox(root, vdata, currentId());
      });
    }

    galleryThumbs(root);
    qtyStepper(root);

    if (buybox) buybox.classList.add('is-initializing');
    applyVariant(startId);
    if (buybox) requestAnimationFrame(function () { buybox.classList.remove('is-initializing'); });

    // Re-measure open collapse panels after fonts/layout settle, so the
    // delivery-frequency dropdown isn't clipped by a stale max-height.
    if (buybox) {
      var remeasure = function () { applyCollapse(buybox); };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
      window.addEventListener('load', remeasure);
      var rt;
      window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(remeasure, 150); }, { passive: true });
    }
  }

  function qtyStepper(root) {
    var qty = root.querySelector('[data-qty]');
    if (!qty) return;
    var input = qty.querySelector('[data-qty-input]');
    var minus = qty.querySelector('[data-qty-minus]');
    var plus = qty.querySelector('[data-qty-plus]');
    function val() { return Math.max(1, parseInt(input.value, 10) || 1); }
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, val() - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = val() + 1; });
    if (input) input.addEventListener('input', function () { input.value = input.value.replace(/[^0-9]/g, ''); });
  }

  function mountGallery(panel) {
    if (!panel) return;
    var el = panel.querySelector('[data-gallery-thumbs-splide]');
    if (!el || !window.Splide || el.classList.contains('is-mounted')) return;
    var count = el.querySelectorAll('.splide__slide').length;
    var sp = new Splide(el, {
      perPage: 5,
      gap: '8px',
      arrows: count > 5,
      pagination: false,
      drag: true,
      type: 'slide',
      breakpoints: { 749: { perPage: 4.5, gap: '6px' } }
    });
    sp.mount();
    el.classList.add('is-mounted');
    panel._dgtGallerySplide = sp;
  }

  function activateThumb(panel, thumb) {
    var main = panel.querySelector('[data-gallery-main]');
    if (!thumb) return;
    if (main) main.src = thumb.dataset.full || (thumb.querySelector('img') && thumb.querySelector('img').src) || main.src;
    panel.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
  }

  function galleryThumbs(root) {
    root.querySelectorAll('[data-gallery-variant]').forEach(function (panel) {
      panel.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-gallery-thumb]');
        if (thumb && panel.contains(thumb)) { activateThumb(panel, thumb); return; }

        var arrowBtn = e.target.closest('.splide__arrow');
        if (arrowBtn && panel.contains(arrowBtn)) {
          var thumbs = Array.prototype.slice.call(panel.querySelectorAll('[data-gallery-thumb]'));
          if (!thumbs.length) return;
          var active = panel.querySelector('[data-gallery-thumb].is-active') || thumbs[0];
          var idx = thumbs.indexOf(active);
          var isPrev = arrowBtn.classList.contains('splide__arrow--prev');
          var next = isPrev ? thumbs[idx - 1] : thumbs[idx + 1];
          if (next) activateThumb(panel, next);
        }
      });
    });
    mountGallery(root.querySelector('[data-gallery-variant].is-active') || root.querySelector('[data-gallery-variant]'));
  }

  function refreshActiveGallery(root) {
    var ap = root.querySelector('[data-gallery-variant].is-active');
    if (!ap) return;
    mountGallery(ap);
    if (ap._dgtGallerySplide) {
      try { ap._dgtGallerySplide.refresh(); } catch (e) {}
    }
  }

  function lockScroll() {
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function nutritionModals() {
    // On mobile, the modal opens without a history entry, so Back navigated the page (leaving
    // the site). Push a throwaway history entry on open; Back then closes the modal instead.
    var nfPushed = false;
    function openNf(modal) {
      modal.hidden = false;
      lockScroll();
      if (!nfPushed) {
        try { history.pushState({ dgtNfModal: true }, ''); } catch (e) {}
        nfPushed = true;
      }
    }
    function closeNf(modal, fromPop) {
      modal.hidden = true;
      unlockScroll();
      if (nfPushed) {
        nfPushed = false;
        // If the user closed it (not via Back), consume our throwaway entry to keep history tidy.
        if (!fromPop && history.state && history.state.dgtNfModal) { try { history.back(); } catch (e) {} }
      }
    }
    function closeAllNf(fromPop) {
      document.querySelectorAll('[data-nf-modal]:not([hidden])').forEach(function (m) { closeNf(m, fromPop); });
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-nf-open]');
      if (openBtn) {
        var modal = document.getElementById(openBtn.getAttribute('data-nf-open'));
        if (modal) openNf(modal);
        return;
      }
      if (e.target.closest('[data-nf-close]') || (e.target.closest('[data-nf-modal]') && e.target.classList.contains('dgt-nf-modal__overlay'))) {
        var m = e.target.closest('[data-nf-modal]');
        if (m) closeNf(m, false);
        return;
      }
      var tab = e.target.closest('[data-nf-tab]');
      if (tab) {
        var modal2 = tab.closest('[data-nf-modal]');
        if (!modal2) return;
        var key = tab.getAttribute('data-nf-tab');
        modal2.querySelectorAll('[data-nf-tab]').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        modal2.querySelectorAll('[data-nf-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-nf-panel') === key); });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllNf(false);
    });
    // Back while a modal is open: the entry is already popped, so just close (don't navigate).
    window.addEventListener('popstate', function () {
      if (nfPushed) closeAllNf(true);
    });
  }

  function boot() {
    document.querySelectorAll('[data-dgt-featured]').forEach(initFeatured);
  }

  function accordionsSingleOpen() {
    document.addEventListener('click', function (e) {
      var head = e.target.closest('.dgt-accordion__head');
      if (!head) return;
      var details = head.parentElement;
      var group = details.closest('.dgt-accordions');
      if (!group) return;
      window.setTimeout(function () {
        if (!details.open) return;
        group.querySelectorAll('details.dgt-accordion[open]').forEach(function (d) {
          if (d !== details) d.open = false;
        });
      }, 0);
    });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  nutritionModals();
  accordionsSingleOpen();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-dgt-featured]');
    if (root) initFeatured(root);
  });
})();
